<script>
import { fb } from '@/lib/common'
export default {
  props: ['fullPath', 'caption'],
  data: () => ({
    url: '/assets/img/noimage.svg'
  }),
  computed: {
    alt () {
      return this.caption || ''
    }
  },
  created () {
    this.setUrl()
    this.getMetadata()
  },
  methods: {
    setUrl () {
      fb.storage().ref(this.fullPath).getDownloadURL()
        .then(url => {
          this.url = url
        })
        .catch(error => console.error(error))
    },
    getMetadata () {
      fb.storage().ref(this.fullPath).getMetadata()
        .then(metadata => {
          this.$emit('getMetadata', metadata)
        })
        .catch(error => console.error(error))
    }
  }
}
</script>

<template>
  <figure>
    <a
      :href="url"
      target="_blank"
    >
      <img
        :src="url"
        :alt="alt"
      >
      <!--<i class="material-icons">open_in_new</i>-->
    </a>
  </figure>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
/*a {
  position: relative;
  i {
    visibility: hidden;
    position: absolute;
    top: -1rem;
    right: -1rem;
    color: variables.$gray-dark;
  }
  &:hover i  {
    visibility: visible;
    animation: expansion .25s 0s ease-out forwards;
  }
}*/
img {
  background-image:
    repeating-linear-gradient( 0deg, #999 0px 1px, transparent 1px 10px),
    repeating-linear-gradient( 90deg, #999 0px 1px, transparent 1px 10px);
}
</style>
